import { render, staticRenderFns } from "./DialogMedicalRecord.vue?vue&type=template&id=78cdfc09"
import script from "./DialogMedicalRecord.vue?vue&type=script&lang=js"
export * from "./DialogMedicalRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports